import { render } from "./associateDataModel.vue?vue&type=template&id=309a1f25&scoped=true"
import script from "./associateDataModel.vue?vue&type=script&lang=js"
export * from "./associateDataModel.vue?vue&type=script&lang=js"

import "./associateDataModel.vue?vue&type=style&index=0&id=309a1f25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309a1f25"]])

export default __exports__